import api from 'api'
import { UIUserPermission } from 'api/admin/userPermissions/permissions'
import {
  ListUserPermissionsRequest,
  ListUserPermissionsResponse,
} from 'api/admin/userPermissions/types'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'

function getRoute(permission: UIUserPermission): string {
  switch (permission) {
    case 'permission_admin':
      return '/admin/permissions/list/permission_admin'
    case 'support_admin':
      return '/admin/permissions/list/support_admin'
    case 'support_specialist':
      return '/admin/permissions/list/support_specialist'
    case 'finance_admin':
      return '/admin/permissions/list/finance_admin'
    case 'company_scope_manager':
      return '/admin/permissions/list/company_scope_manager'
    default:
      permission satisfies never
      throw new Error(`Unhandled permission: ${permission}`)
  }
}

export async function listUserPermissions(
  request: ListUserPermissionsRequest = {},
  permission: UIUserPermission
): Promise<ListUserPermissionsResponse> {
  const route = getRoute(permission)
  const result = await api.get(route, {
    params: {
      cursor: request.cursor,
      direction: request.direction ?? 'next',
      user_id: request.userId,
      permission: request.permission,
      page_size: request.pageSize,
    },
    paramsSerializer: queryParamSerializer,
  })

  return result.data as ListUserPermissionsResponse
}
